import Alpine from "alpinejs";

Alpine.data("contentSlider", (length) => ({
    slide: 0,
    slide_count: length,
    prev() {
        this.slide = (this.slide_count + this.slide - 1) % this.slide_count;
    },
    next() {
        this.slide = (this.slide + 1) % this.slide_count;
    },
}));
